import { render, staticRenderFns } from "./PicklrDetails.vue?vue&type=template&id=280484a2&scoped=true&"
import script from "./PicklrDetails.vue?vue&type=script&lang=ts&"
export * from "./PicklrDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PicklrDetails.vue?vue&type=style&index=0&id=280484a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280484a2",
  null
  
)

export default component.exports